import { LeadCloseReason, LeadCloseReasonLabels, LeadStage, LeadStageLabels } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';
import type { BadgeVariant } from 'noddi-ui-web';

// nsdk keys the labels by member name (`OPEN`), not by the API value (`open`).
export const LEAD_STAGE_LABEL: Record<LeadStage, string> = {
  [LeadStage.OPEN]: LeadStageLabels.OPEN,
  [LeadStage.OFFERED]: LeadStageLabels.OFFERED,
  [LeadStage.WON]: LeadStageLabels.WON,
  [LeadStage.CLOSED]: LeadStageLabels.CLOSED
};

export const LEAD_STAGE_ICON: Record<LeadStage, NoddiIconName> = {
  [LeadStage.OPEN]: 'Flag',
  [LeadStage.OFFERED]: 'Send',
  [LeadStage.WON]: 'Handshake',
  [LeadStage.CLOSED]: 'CircleX'
};

// Open is the one staff must act on; a closed lead needs nothing, so it carries no hue.
export const LEAD_STAGE_BADGE_VARIANT: Record<LeadStage, BadgeVariant> = {
  [LeadStage.OPEN]: 'warning',
  [LeadStage.OFFERED]: 'info',
  [LeadStage.WON]: 'success',
  [LeadStage.CLOSED]: 'outline'
};

export const LEAD_CLOSE_REASON_LABEL: Record<LeadCloseReason, string> = {
  [LeadCloseReason.CUSTOMER_DECLINED]: LeadCloseReasonLabels.CUSTOMER_DECLINED,
  [LeadCloseReason.NO_RESPONSE]: LeadCloseReasonLabels.NO_RESPONSE,
  [LeadCloseReason.DUPLICATE]: LeadCloseReasonLabels.DUPLICATE,
  [LeadCloseReason.NOT_RELEVANT]: LeadCloseReasonLabels.NOT_RELEVANT,
  [LeadCloseReason.OFFER_WITHDRAWN]: LeadCloseReasonLabels.OFFER_WITHDRAWN,
  [LeadCloseReason.ORDER_CANCELED]: LeadCloseReasonLabels.ORDER_CANCELED,
  [LeadCloseReason.OTHER]: LeadCloseReasonLabels.OTHER
};
